// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"style_textContainer__AtAuC","marginLeft":"style_marginLeft__vnxiF","container":"style_container__Nm9fi"};